export const formatUser = ({
  created_at,
  job_title,
  name,
  picture,
}: {
  created_at?: number
  job_title?: string
  name: string
  picture?: string
}): {
  date: number
  job: string
  name: string
  picture: string | undefined
} => ({
  date: created_at || 0,
  job: job_title || '',
  name,
  picture,
})
